/**
 * @class
 */
import Base from 'netxcore@netx/core-cms/models/CMSBlock';

import AssetModel from '@netx/core-asset/models/asset';
import CartAssetsCollection from '@netx/core-cart/collections/cartAssets';
import CategoryAssetsCollection from '@netx/core-category/collections/categoryAssets';
import CategoryModel from '@netx/core-category/models/category';
import CategoriesCollection from '@netx/core-category/collections/categories';

export default class CMSBlock extends Base {
	/**
	 * _parse decomposes and applies the server data for a block,
	 * managing the unpacking of 'goo' and the instantiation of the assets collection --
	 * either from an 'assets' array/collection containing data (the client's representation),
	 * or an 'assetIds' array  containing ids (as stored on the server).
	 *
	 * @param {object} attrs unparsed attributes
	 * @param {object} opts backbone options
	 */
	_parse(attrs, opts) {
		const attributes = this.unpackAttrs(attrs);
		this.set(attributes, {parse: false});

		const contentIds = this.get('contentIds');
		const cId = contentIds ? contentIds[0] : undefined;

		let assetModel, cartCollection, categoryCollection;

		// only parse the assets of blocks that have assets
		switch (attributes.type) {
			case 'asset':
				assetModel = new AssetModel();
				if (cId) {
					assetModel.set({assetId: cId}, {parse: false});
					assetModel.fetch().then(
						() => {
							// assetPreviewView doesn't wait for the model to fetch
							this.trigger('change:assetId', this, this.get('assetId'));
						},
						(err) => {
							this.trigger('change:assetId', this, this.get('assetId'));
						},
					);
				}
				this.set({assetModel: assetModel}, {parse: false});

				break;
			case 'category':
				if (!cId) {
					categoryCollection = new CategoryAssetsCollection([], {
						pagerRoutes: false,
					});
					categoryCollection.pageSize = categoryCollection.chunkSize;
					this.categoryCollection = categoryCollection;
				} else if (cId != this.get('categoryId')) {
					this.set({categoryId: cId}, {parse: false});

					categoryCollection = new CategoriesCollection([], {
						currentCat: new CategoryModel({categoryid: cId}),
						pagerRoutes: false,
					});
					categoryCollection.pageSize = categoryCollection.chunkSize;
					categoryCollection.fetch();
					this.categoryCollection = categoryCollection;
				}

				break;

			case 'carousel':
			case 'categoryAssetList':
				if (!cId) {
					categoryCollection = new CategoryAssetsCollection([], {
						pagerRoutes: false,
					});
					categoryCollection.pageSize = categoryCollection.chunkSize;
					this.categoryCollection = categoryCollection;
				} else if (cId != this.get('categoryId')) {
					this.set({categoryId: cId}, {parse: false});

					categoryCollection = new CategoryAssetsCollection([], {
						categoryId: cId,
						pagerRoutes: false,
					});
					categoryCollection.pageSize = categoryCollection.chunkSize;
					categoryCollection.fetch();

					// this will pass the block options to the listItemViews and update as the block updates
					categoryCollection.block = this;

					this.categoryCollection = categoryCollection;
				}

				break;

			case 'savedCart':
				// DAM-19561 - existing collection blocks do not have this data
				this.set({
					listButtonDownload: true,
					listButtonCart: true,
					displayListItemName: '1',
				});

				if (!cId) {
					cartCollection = new CartAssetsCollection([], {pagerRoutes: false});
					cartCollection.pageSize = cartCollection.chunkSize;
					this.cartCollection = cartCollection;
				} else if (cId != this.get('cartId')) {
					this.set({cartId: cId}, {parse: false});
					cartCollection = new CartAssetsCollection([], {pagerRoutes: false});
					cartCollection.pageSize = cartCollection.chunkSize;
					cartCollection.pager.set({routesToPage: false});
					cartCollection.fetchSavedCart(parseInt(cId));
					this.cartCollection = cartCollection;
				}

				if (cartCollection) {
					cartCollection.block = this;
				}

				break;

			//case 'html':
			default:
				attributes.assetIds = [];
				break;
		}
	}
}
